import React from 'react';
import Proptypes from 'prop-types'

const DefaultFallback = ({message}) => {
    return(
      <div role="alert">
        <h3 style={{marginTop: '0', fontSize: '0.8rem'}}>Error loading {message}... see log for details</h3>
      </div>
    )
  }

DefaultFallback.propTypes = {
  message: Proptypes.string.isRequired
}

export default DefaultFallback;
